// extracted by mini-css-extract-plugin
export default {"productGallery":"lG-z","inQuickShop":"mG-z"};